export default {
  zh: {
    // 首页案例标题
    title: "全球领先企业的信赖之选",
    // 案例类型
    types: {
      manufacturing: "制造业｜数字化转型解决方案",
      consumer: "消费品｜出海解决方案",
      service: "服务商｜云上降本解决方案",
    },
    // 标签
    tags: {
      challenge: "业务挑战",
      solution: "解决方案",
      results: "关键成果",
    },
    // 首页三个主要案例
    manufacturing: {
      challenge:
        "制造企业在全球化扩张中面临数据分散、系统割裂、运维成本高、缺乏设备故障预测能力等问题，整体运营效率受限。",
      solution:
        "我们为企业提供覆盖数据整合、系统上云、业务系统优化的整体解决方案，建立统一的数据基础平台，提升生产过程透明度和运维管理水平。通过结构化实施方法和持续技术支持，帮助企业稳步完成数字化建设，提升整体运营效率。",
      results: {
        compliance: {
          title: "业务出海合规：",
          desc: "成功构建了符合欧洲当地法规的数据架构。",
        },
        innovation: {
          title: "加速业务创新：",
          desc: "应用开发与部署速度显著提升，能快速响应市场变化。",
        },
        intelligence: {
          title: "实现智能运维：",
          desc: "通过AI赋能，有效优化了复杂业务的解决路径。",
        },
      },
      resultTitle: {
        h1: "构建合规云架构",
        h2: "赋能能源巨头高效出海",
      },
    },
    consumer: {
      challenge:
        "品牌出海过程中，业务快速增长，对全球基础设施的稳定性、合规性和用户访问体验提出了更高要求。",
      solution:
        "我们为企业构建覆盖多区域的云基础环境，确保核心业务系统稳定运行，并实现数据的安全合规管理。通过统一的技术架构、多语言支持和跨地区加速能力，提升海外用户访问体验，帮助企业顺利落地全球业务运营。",
      results: {
        reliability: {
          title: "业务稳定可靠：",
          desc: "为核心业务提供了高达99.99%的可用性保障。",
        },
        experience: {
          title: "全球体验一致：",
          desc: "确保了全球顾客流畅、一致的移动端点单体验。",
        },
        security: {
          title: "数据支付安全：",
          desc: "建立了满足全球运营需求的安全合规的支付体系。",
        },
      },
      resultTitle: {
        h1: "以高可用云基座",
        h2: "支撑全球咖啡品牌极速扩张",
      },
    },
    service: {
      challenge:
        "广告平台日均处理海量请求，需要在大规模访问下保持系统稳定，同时降低带宽与资源成本压力。",
      solution:
        "我们为其构建跨云架构，统一管理多平台资源，并通过弹性调度和智能流量分配提升系统稳定性。结合全链路监控与快速告警机制，实现故障及时定位与处理。在保障业务连续性的同时有效降低整体流量与基础设施成本。",
      results: {
        cost: {
          title: "大幅降低成本：",
          desc: "通过高效调度，显著节省了高峰期的流量带宽成本。",
        },
        stability: {
          title: "系统稳定运行：",
          desc: "成功满足高并发业务的弹性需求，保障业务7x24不中断。",
        },
        efficiency: {
          title: "运维效率提升：",
          desc: "实现了分钟级的故障定位能力，极大提升了响应速度。",
        },
      },
      resultTitle: {
        h1: "为高并发广告平台",
        h2: "打造兼顾成本与性能的多云方案",
      },
    },
    // 按钮
    buttons: {
      consultExpert: "预约专家咨询",
      viewAll: "查看全部案例",
    },
    // 首屏内容
    hero: {
      title: "真实客户实践，验证多云管理价值",
      titleHighlight: "支撑全球业务稳健增长",
      description:
        "服务制造、零售、金融与互联网等多个行业，基于真实业务场景设计多云解决方案，<br />帮助企业在优化成本的同时提升效率，为全球业务扩展提供稳定、可持续的云基础支撑。",
    },
    // 案例展示区域
    section: {
      title: "成功案例展示",
      description:
        "我们与各行业的领先企业合作，通过专业的云成本管理方案，帮助他们实现了显著的成本降低和效率提升",
    },
    // 客户案例列表
    list: {
      tebian: {
        title: "特变电工",
        description:
          "作为全球知名的变压器制造商，特变电工通过Cycor一站式云成本管理方案，实现了多云环境下30%的成本节约和运维效率显著提升。",
      },
      kudi: {
        title: "KuDi Coffee",
        description:
          "快速发展的连锁咖啡品牌KuDi通过Cycor的云资源优化方案，在全球业务扩张过程中实现了云成本的精准控制和40%的资源利用率提升。",
      },
      zmaticoo: {
        title: "ZMaticoo",
        description:
          "作为领先的广告技术公司，ZMaticoo借助Cycor的智能分析平台，实现了大数据处理成本25%的降低和实时性能的显著优化。",
      },
      company4: {
        title: "创新科技",
        description:
          "通过Cycor的DevFinOps解决方案，创新科技在云原生转型过程中实现了开发成本可视化和35%的资源优化效果。",
      },
      company5: {
        title: "医疗健康",
        description:
          "借助Cycor的多云管理平台，医疗健康企业在合规性要求下实现了医疗数据处理成本的20%降低。",
      },
      company6: {
        title: "游戏娱乐",
        description:
          "通过Cycor的弹性资源管理，游戏公司在峰值流量处理中实现了50%的成本节约和用户体验的持续优化。",
      },
      company7: {
        title: "在线教育",
        description:
          "教育科技公司通过Cycor的SaaS成本优化方案，在用户快速增长期间保持了稳定的单位成本控制。",
      },
      company8: {
        title: "物流配送",
        description:
          "大型物流企业采用Cycor的大数据分析方案，实现了运输路径优化和仓储成本30%的有效降低。",
      },
      company9: {
        title: "媒体流媒体",
        description:
          "视频流媒体平台通过Cycor的CDN优化方案，在全球内容分发中实现了带宽成本45%的大幅节约。",
      },
      // 新增案例数据
      digitalEntertainment: {
        title: "数字娱乐｜全球化平台解决方案",
        challenge:
          "随着全球用户增长，海外直播延迟、跨语言内容管理困难及海量数据处理效率低等问题逐渐凸显。",
        solution:
          "我们部署覆盖多区域的 CDN 与服务架构，降低跨国访问延迟；提供多语言内容处理与审核能力，支持本地化运营需求。通过构建统一的数据处理流程，实现实时数据汇集、分析与分发，提升全球平台的整体服务效率。",
        results: {
          flow: {
            title: "全球体验流畅",
            desc: "通过多种方式优化网络路径,全球访问延迟降低50%以上。",
          },
          localization: {
            title: "内容智能本地化",
            desc: "支持20+种主流语言实时翻译与内容智能审核。",
          },
          engagement: {
            title: "用户粘性提升",
            desc: "个性化智能推荐模型将用户粘性提升了30%。",
          },
        },
        resultTitle: {
          h1: "构建全球娱乐生态",
          h2: "实现20亿粉丝的全球化触达和变现",
        },
      },
      sdwan: {
        title: "SD-WAN｜云原生网络解决方案",
        challenge:
          "传统 MPLS 专线成本高、部署慢，企业多云环境难以统一管理，跨地域网络连接与运维愈加复杂。",
        solution:
          "我们为其构建新一代云原生 SD-WAN 平台，以全球骨干网络替代传统专线，实现多云环境的统一接入与安全互联；通过集中管理提升网络可视性，并利用自动化运维工具，加强网络稳定性与跨区域访问体验。",
        results: {
          performance: {
            title: "网络性能跃升",
            desc: "全球网络延迟降低60%，网络可用性达到99.99%。",
          },
          deployment: {
            title: "部署效率提升",
            desc: "客户网络部署时间从数月缩短至数天，扩展速度提升3倍。",
          },
          maintenance: {
            title: "运维成本降低",
            desc: "网络运维成本降低50%，带宽利用率提升40%。",
          },
        },
        resultTitle: {
          h1: "服务世界五百强：毫秒级延迟",
          h2: "99.99%高可用全球网络",
        },
      },
      crossBorderEcommerce: {
        title: "跨境电商｜全球化技术解决方案",
        challenge:
          "随着全球用户访问量增长，跨境电商在应对高并发访问、高流量冲击、多产品线架构整合以及资源统一调度方面面临挑战。同时，还需满足全球范围内的支付合规与数据治理要求。",
        solution:
          "我们构建了高性能、高可用的全球电商技术基础设施。通过部署全球 CDN 和智能负载均衡提升跨区域访问体验；基于 GKE 多区域微服务架构，实现多产品线的快速部署与弹性扩展；同时整合智能支付与合规安全体系，为跨境支付提供全链路安全保障。",
        results: {
          performance: {
            title: "全球性能提升",
            desc: "全球页面加载速度提升70%，移动端转化率提升25%。",
          },
          infrastructure: {
            title: "基础设施成本优化",
            desc: "基础设施成本降低40%，运维效率提升50%。",
          },
          experience: {
            title: "用户体验升级",
            desc: "全球用户满意度提升35%，客户留存率提升20%。",
          },
        },
        resultTitle: {
          h1: "支持三大产品线全球业务扩展",
          h2: "新增海外市场收入占比达到60%",
        },
      },
      gaming: {
        title: "游戏｜全球化技术解决方案",
        challenge:
          "需保障8亿全球用户的低延迟游戏体验，处理TB级游戏数据的实时分析，并实现基于文化的精准化运营。",
        solution:
          "我们为其构建了支撑8亿+用户的高性能游戏基础设施。构建全球低延迟游戏基础设施；搭建支持每秒百万级事件的海量数据处理与智能分析平台；并利用Firebase快速实现社交、用户追踪和消息推送等功能。",
        results: {
          experience: {
            title: "游戏体验提升",
            desc: "全球游戏延迟降低至50ms以内，用户体验满意度提升45%。",
          },
          growth: {
            title: "用户增长显著",
            desc: "新用户获取成本降低30%，用户留存率提升25%。",
          },
          monetization: {
            title: "商业化成果斐然",
            desc: "广告收入提升35%，内购转化率提升20%。",
          },
        },
        resultTitle: {
          h1: "支撑8亿+用户高性能游戏体验",
          h2: "助力文化游戏全球化发行",
        },
      },
      gamingSocial: {
        title: "游戏社交｜文化出海解决方案",
        challenge:
          "竞技游戏需毫秒级实时同步，社交产品需支持全球实时音视频互动，且文化内容需精准本地化并满足合规要求。",
        solution:
          "我们为其构建了全球化的游戏运营基础设施。通过Firebase和Agones on GKE等服务，保障游戏的实时同步与社交互动；搭建由VertexAI驱动的文化内容本地化平台，实现翻译、元素适配和智能审核；并建立海量数据分析体系。",
        results: {
          experience: {
            title: "全球体验极致",
            desc: "游戏延迟降低至30ms以内，全球用户满意度提升40%。",
          },
          localization: {
            title: "文化传播精准",
            desc: "文化内容本地化准确率达95%，文化认同度提升50%。",
          },
          value: {
            title: "商业价值提升",
            desc: "海外市场收入占比提升至45%，文化出海ROI提升80%。",
          },
        },
        resultTitle: {
          h1: "国家文化出口重点企业",
          h2: "助力中国文创产品走向世界",
        },
      },
      entertainment: {
        title: "泛娱乐｜全球内容平台解决方案",
        challenge:
          "4K超清内容的全球低成本分发与流畅播放，千万级并发下的AI个性化实时推荐，以及高并发的实时弹幕社区互动。",
        solution:
          "我们为其构建了全球化的内容分发与互动平台。通过Media CDN实现4K内容的低成本、高质量智能分发；利用VertexAI构建多模态实时个性化推荐引擎；并基于Firebase打造支持毫秒级同步的全球分布式弹幕系统。",
        results: {
          viewing: {
            title: "极致观影体验",
            desc: "4K HDR内容加载时间缩短60%，播放卡顿率降低80%。",
          },
          recommendation: {
            title: "精准个性化推荐",
            desc: "用户内容发现效率提升40%，平均观看时长增加35%。",
          },
          community: {
            title: "社区高度活跃",
            desc: "实时互动响应时间控制在50ms内，用户参与度提升50%。",
          },
        },
        resultTitle: {
          h1: "实现全球用户的极致观影体验和",
          h2: "内容创作者的全方位赋能",
        },
      },
    },
    // 标签系统（案例分类标签）
    caseTags: {
      manufacturing: "制造业",
      digital: "数字化转型",
      retail: "零售连锁",
      global: "全球化",
      adtech: "广告技术",
      optimization: "成本优化",
      finance: "金融科技",
      cloud: "云原生",
      healthcare: "医疗健康",
      ai: "人工智能",
      gaming: "游戏娱乐",
      infrastructure: "基础设施",
      education: "在线教育",
      saas: "SaaS平台",
      logistics: "物流配送",
      bigdata: "大数据",
      media: "媒体娱乐",
      streaming: "流媒体",
      // 新增标签
      entertainment: "娱乐",
      sdwan: "SD-WAN",
      ecommerce: "电商",
      socialGaming: "社交游戏",
      culturalExport: "文化出海",
      contentPlatform: "内容平台",
    },
    // 操作按钮
    loadMore: "查看更多案例",
    loadMoreButton: "查看更多",
    // 联系按钮
    contactUs: "联系我们",
  },
  en: {
    // Homepage cases title
    title: "Trusted Choice of Leading Global Enterprises",
    // Case types
    types: {
      manufacturing: "Manufacturing | Digital Transformation",
      consumer: "Consumer Goods | Global Expansion",
      service: "Service Provider | Cloud Cost Optimization",
    },
    // Tags
    tags: {
      challenge: "Challenge",
      solution: "Solution",
      results: "Results",
    },
    // Three main cases on homepage
    manufacturing: {
      challenge:
        "Expanding to Europe faced strict compliance and high IT O&M costs, lacking AI-driven fault detection experience.",
      solution:
        "Delivered end-to-end solutions: cloud migration, compliance, and AI-powered process optimization.",
      results: {
        compliance: {
          title: "Compliance:",
          desc: "Built data architecture meeting European regulations.",
        },
        innovation: {
          title: "Accelerated Innovation:",
          desc: "Improved development and deployment speed, enabling fast market response.",
        },
        intelligence: {
          title: "Intelligent Operations:",
          desc: "AI optimized complex business solution paths.",
        },
      },
      resultTitle: {
        h1: "Compliant Cloud Architecture",
        h2: "Enabling Efficient Global Expansion",
      },
    },
    consumer: {
      challenge:
        "Rapid global growth challenged IT stability, security, and user experience.",
      solution:
        "Built global cloud with 99.99% uptime, multi-language H5 apps, and serverless auto-scaling.",
      results: {
        reliability: {
          title: "Stability:",
          desc: "Ensured 99.99% availability for core business.",
        },
        experience: {
          title: "Global Experience:",
          desc: "Delivered smooth, consistent mobile experience worldwide.",
        },
        security: {
          title: "Data Security:",
          desc: "Established secure, compliant global payment system.",
        },
      },
      resultTitle: {
        h1: "High-Availability Cloud Foundation",
        h2: "Supporting Global Coffee Brand Expansion",
      },
    },
    service: {
      challenge:
        "Advertising platform with 230B+ daily requests needed to control traffic costs while ensuring stability.",
      solution:
        "Deployed multi-cloud with elastic resources, networking, and observability to cut costs.",
      results: {
        cost: {
          title: "Cost Savings:",
          desc: "Reduced peak traffic bandwidth costs via efficient scheduling.",
        },
        stability: {
          title: "Stable Operation:",
          desc: "Met high-concurrency demands, ensuring 24/7 business continuity.",
        },
        efficiency: {
          title: "Operational Efficiency:",
          desc: "Minute-level fault detection improved response speed.",
        },
      },
      resultTitle: {
        h1: "High-Concurrency Ad Platform",
        h2: "Balancing Cost and Performance with Multi-Cloud",
      },
    },
    // Buttons
    buttons: {
      consultExpert: "Book Expert Consultation",
      viewAll: "View All Cases",
    },
    // Hero section
    hero: {
      title: "Real Customer Practices, Validating Multi-Cloud Management Value",
      titleHighlight: "Supporting Steady Global Business Growth",
      description:
        "Serving manufacturing, retail, finance, internet and other industries, designing multi-cloud solutions based on real business scenarios,<br />helping enterprises improve efficiency while optimizing costs, providing stable and sustainable cloud infrastructure support for global business expansion.",
    },
    // Cases showcase section
    section: {
      title: "Success Stories",
      description:
        "We partner with leading enterprises across industries, helping them achieve significant cost reduction and efficiency improvement through professional cloud cost management solutions",
    },
    // Customer case list
    list: {
      tebian: {
        title: "TBEA",
        description:
          "As a globally renowned transformer manufacturer, TBEA achieved 30% cost savings and significant operational efficiency improvement in multi-cloud environments through Cycor's one-stop cloud cost management solution.",
      },
      kudi: {
        title: "KuDi Coffee",
        description:
          "Fast-growing coffee chain KuDi achieved precise cloud cost control and 40% resource utilization improvement during global business expansion through Cycor's cloud resource optimization solution.",
      },
      zmaticoo: {
        title: "ZMaticoo",
        description:
          "As a leading advertising technology company, ZMaticoo achieved 25% reduction in big data processing costs and significant real-time performance optimization through Cycor's intelligent analytics platform.",
      },
      company4: {
        title: "InnoTech",
        description:
          "Through Cycor's DevFinOps solution, InnoTech achieved development cost visibility and 35% resource optimization during cloud-native transformation.",
      },
      company5: {
        title: "HealthCare Plus",
        description:
          "With Cycor's multi-cloud management platform, healthcare enterprises achieved 20% reduction in medical data processing costs under compliance requirements.",
      },
      company6: {
        title: "GameZone",
        description:
          "Through Cycor's elastic resource management, the gaming company achieved 50% cost savings in peak traffic handling and continuous user experience optimization.",
      },
      company7: {
        title: "EduTech Online",
        description:
          "Educational technology companies maintained stable unit cost control during rapid user growth through Cycor's SaaS cost optimization solution.",
      },
      company8: {
        title: "LogiFlow",
        description:
          "Large logistics enterprises achieved transportation route optimization and 30% effective reduction in warehousing costs through Cycor's big data analytics solution.",
      },
      company9: {
        title: "StreamMedia Pro",
        description:
          "Video streaming platforms achieved 45% significant bandwidth cost savings in global content distribution through Cycor's CDN optimization solution.",
      },
      // New case data
      digitalEntertainment: {
        title: "Digital Entertainment | Global Platform Solution",
        challenge:
          "With the global expansion of its talent matrix, it faced high overseas live streaming latency, difficult multi-language content compliance, and slow real-time processing and analysis of massive user data.",
        solution:
          "We reduced network latency by deploying global CDN and multi-regional microservice architecture. Used AI to achieve real-time multi-language translation and intelligent content moderation, ensuring localized operations and content compliance. Built real-time data streaming pipelines and data warehouses to achieve unified analysis and intelligent recommendations for global user data.",
        results: {
          flow: {
            title: "Smooth Global Experience",
            desc: "Optimized network paths in various ways, reducing global access latency by over 50%.",
          },
          localization: {
            title: "Intelligent Content Localization",
            desc: "Supports real-time translation and intelligent content moderation for 20+ mainstream languages.",
          },
          engagement: {
            title: "Enhanced User Stickiness",
            desc: "Personalized intelligent recommendation model increased user stickiness by 30%.",
          },
        },
        resultTitle: {
          h1: "Building Global Entertainment Ecosystem",
          h2: "Achieving Global Reach and Monetization of 2 Billion Fans",
        },
      },
      sdwan: {
        title: "SD-WAN | Cloud-Native Network Solution",
        challenge:
          "Traditional MPLS private lines are expensive and slow to deploy, enterprise customers' multi-cloud environments need unified management, and global network node monitoring and intelligent O&M are complex.",
        solution:
          "We helped build a next-generation cloud-native SD-WAN platform. Replaced traditional expensive private lines with global backbone networks; achieved unified management and secure interconnection through multi-cloud management platforms; and built AI intelligent O&M platforms to provide network performance prediction and second-level fault recovery capabilities.",
        results: {
          performance: {
            title: "Network Performance Leap",
            desc: "Global network latency reduced by 60%, network availability reached 99.99%.",
          },
          deployment: {
            title: "Deployment Efficiency Improvement",
            desc: "Customer network deployment time shortened from months to days, expansion speed increased by 3 times.",
          },
          maintenance: {
            title: "O&M Cost Reduction",
            desc: "Network O&M costs reduced by 50%, bandwidth utilization increased by 40%.",
          },
        },
        resultTitle: {
          h1: "Serving Fortune 500: Millisecond Latency",
          h2: "99.99% High-Availability Global Network",
        },
      },
      crossBorderEcommerce: {
        title: "Cross-Border E-commerce | Global Technology Solution",
        challenge:
          "High global user access latency and high concurrent traffic, multi-product technical architecture and resource allocation need unified optimization, and must meet global payment and data compliance requirements.",
        solution:
          "We built high-performance, high-availability global e-commerce infrastructure. Deployed global CDN and intelligent load balancing to improve access performance; built GKE multi-region microservice architecture to support independent deployment and elastic scaling of multiple product lines; and integrated intelligent payment and compliance security systems to ensure cross-border payment and global compliance security.",
        results: {
          performance: {
            title: "Global Performance Enhancement",
            desc: "Global page loading speed improved by 70%, mobile conversion rate increased by 25%.",
          },
          infrastructure: {
            title: "Infrastructure Cost Optimization",
            desc: "Infrastructure costs reduced by 40%, O&M efficiency improved by 50%.",
          },
          experience: {
            title: "User Experience Upgrade",
            desc: "Global user satisfaction increased by 35%, customer retention rate improved by 20%.",
          },
        },
        resultTitle: {
          h1: "Supporting Three Product Lines' Global Business Expansion",
          h2: "New Overseas Market Revenue Share Reached 60%",
        },
      },
      gaming: {
        title: "Gaming | Global Technology Solution",
        challenge:
          "Need to ensure low-latency gaming experience for 800 million global users, process TB-level real-time analysis of game data, and achieve culture-based precision operations.",
        solution:
          "We built high-performance gaming infrastructure supporting 800 million+ users. Built global low-latency gaming infrastructure; constructed massive data processing and intelligent analysis platforms supporting millions of events per second; and utilized Firebase to quickly implement social, user tracking, and push notification functions.",
        results: {
          experience: {
            title: "Gaming Experience Enhancement",
            desc: "Global gaming latency reduced to within 50ms, user experience satisfaction increased by 45%.",
          },
          growth: {
            title: "Significant User Growth",
            desc: "New user acquisition cost reduced by 30%, user retention rate improved by 25%.",
          },
          monetization: {
            title: "Outstanding Commercialization Results",
            desc: "Advertising revenue increased by 35%, in-app purchase conversion rate improved by 20%.",
          },
        },
        resultTitle: {
          h1: "Supporting 800 Million+ Users' High-Performance Gaming Experience",
          h2: "Empowering Global Publishing of Cultural Games",
        },
      },
      gamingSocial: {
        title: "Gaming Social | Cultural Going Global Solution",
        challenge:
          "Competitive games need millisecond-level real-time synchronization, social products need to support global real-time audio-video interaction, and cultural content needs precise localization while meeting compliance requirements.",
        solution:
          "We built globalized gaming operation infrastructure. Through Firebase and Agones on GKE services, ensured real-time synchronization and social interaction in games; built VertexAI-powered cultural content localization platform to achieve translation, element adaptation, and intelligent moderation; and established massive data analysis systems.",
        results: {
          experience: {
            title: "Ultimate Global Experience",
            desc: "Gaming latency reduced to within 30ms, global user satisfaction increased by 40%.",
          },
          localization: {
            title: "Precise Cultural Communication",
            desc: "Cultural content localization accuracy reached 95%, cultural recognition improved by 50%.",
          },
          value: {
            title: "Business Value Enhancement",
            desc: "Overseas market revenue share increased to 45%, cultural going global ROI improved by 80%.",
          },
        },
        resultTitle: {
          h1: "National Cultural Export Key Enterprise",
          h2: "Helping Chinese Cultural Products Go Global",
        },
      },
      entertainment: {
        title: "Pan-Entertainment | Global Content Platform Solution",
        challenge:
          "Global low-cost distribution and smooth playback of 4K ultra-high definition content, AI personalized real-time recommendations under tens of millions of concurrent users, and high-concurrency real-time bullet screen community interaction.",
        solution:
          "We built a globalized content distribution and interaction platform. Achieved low-cost, high-quality intelligent distribution of 4K content through Media CDN; built multi-modal real-time personalized recommendation engines using VertexAI; and created globally distributed bullet screen systems supporting millisecond-level synchronization based on Firebase.",
        results: {
          viewing: {
            title: "Ultimate Viewing Experience",
            desc: "4K HDR content loading time reduced by 60%, playback stuttering rate decreased by 80%.",
          },
          recommendation: {
            title: "Precise Personalized Recommendations",
            desc: "User content discovery efficiency improved by 40%, average viewing time increased by 35%.",
          },
          community: {
            title: "Highly Active Community",
            desc: "Real-time interaction response time controlled within 50ms, user engagement increased by 50%.",
          },
        },
        resultTitle: {
          h1: "Achieving Ultimate Global User Viewing Experience and",
          h2: "Comprehensive Empowerment of Content Creators",
        },
      },
    },
    // Tag system (case category tags)
    caseTags: {
      manufacturing: "Manufacturing",
      digital: "Digital Transformation",
      retail: "Retail Chain",
      global: "Globalization",
      adtech: "AdTech",
      optimization: "Cost Optimization",
      finance: "FinTech",
      cloud: "Cloud Native",
      healthcare: "Healthcare",
      ai: "Artificial Intelligence",
      gaming: "Gaming",
      infrastructure: "Infrastructure",
      education: "Online Education",
      saas: "SaaS Platform",
      logistics: "Logistics",
      bigdata: "Big Data",
      media: "Media",
      streaming: "Streaming",
      // New tags
      entertainment: "Entertainment",
      sdwan: "SD-WAN",
      ecommerce: "E-commerce",
      socialGaming: "Social Gaming",
      culturalExport: "Cultural Export",
      contentPlatform: "Content Platform",
    },
    // Action buttons
    loadMore: "Load More Cases",
    loadMoreButton: "Load More",
    // Contact button
    contactUs: "Contact Us",
  },
};
